import { VideoAsset, VideoViewType } from '$Utilities/models/videoViews';
import { useEffect } from 'react';
import { useVideoPlayerSync } from '$State/VideoPlayerSync/VideoPlayerSyncContext';
import SingleView from './SingleView';
import DoubleView from './DoubleView';
import GridView from './GridView';
import FullscreenView from './FullscreenView';
import { React } from 'Imports';

interface VideoViewsLayoutProps {
    activeViewType: VideoViewType;
    numberOfChannels: number;
    primaryChannelNumber: number;
    videoAssets: VideoAsset[];
    activeFullScreen: boolean;
    onCloseFullScreen?: () => void;
    onVideosStarted?: () => void;
    onVideosWatched?: () => void;
    onVideoDownloaded?: () => void;
}

export interface LayoutProps {
    videoAssets: VideoAsset[];
    primaryChannelNumber: number;
    onVideoDownloaded?: () => void;
}

const layouts = {
    Single: SingleView,
    Double: DoubleView,
    Grid: GridView,
    'Full Screen': FullscreenView,
};

const VideoViewsLayout = (props: VideoViewsLayoutProps) => {
    const { isFullView, setIsFullView, setDisableSync, setIsPlayingGlobal, videosStarted, videosWatched } = useVideoPlayerSync();

    useEffect(() => {
        if (props.activeFullScreen !== isFullView) {
            setIsFullView(props.activeFullScreen);
            setDisableSync(props.activeFullScreen);
            if (props.activeFullScreen) {
                setIsPlayingGlobal(false);
            }
        }
    }, [props.activeFullScreen, isFullView, setIsFullView, setDisableSync, setIsPlayingGlobal]);

    useEffect(() => {
        if (videosStarted) {
            props.onVideosStarted && props.onVideosStarted();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videosStarted]);

    useEffect(() => {
        if (videosWatched) {
            props.onVideosWatched && props.onVideosWatched();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videosWatched]);

    const SelectedLayout = layouts[props.activeViewType];
    return (
        <>
            <SelectedLayout
                videoAssets={props.videoAssets}
                primaryChannelNumber={props.primaryChannelNumber}
                onVideoDownloaded={props.onVideoDownloaded}
            />
            {isFullView && (
                <FullscreenView
                    videoAssets={props.videoAssets}
                    primaryChannelNumber={props.primaryChannelNumber}
                    onVideoDownloaded={props.onVideoDownloaded}
                    numberOfChannels={props.numberOfChannels}
                    onCloseFullScreen={() => props.onCloseFullScreen && props.onCloseFullScreen()}
                />
            )}
        </>
    );
};

export default VideoViewsLayout;
